'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __chunk_1 = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);

function reducer(state, action) {
  switch (action.type) {
    case 'load':
      return {
        loading: true,
        success: false,
        error: null,
        response: null
      };

    case 'success':
      return {
        loading: false,
        success: true,
        error: null,
        response: action.payload || null
      };

    case 'error':
      return {
        loading: false,
        success: false,
        error: action.payload || true,
        response: null
      };

    default:
      throw new Error("Unkown action type: \"".concat(action.type, "\""));
  }
}

function useLoadingState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? false : _ref$success,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$response = _ref.response,
      response = _ref$response === void 0 ? null : _ref$response;

  var _useReducer = React.useReducer(reducer, {
    loading: loading,
    success: success,
    error: error,
    response: response
  }),
      _useReducer2 = __chunk_1.slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return {
    state: state,
    dispatchLoad: function dispatchLoad() {
      return dispatch({
        type: 'load'
      });
    },
    dispatchError: function dispatchError(payload) {
      return dispatch({
        type: 'error',
        payload: payload
      });
    },
    dispatchSuccess: function dispatchSuccess(payload) {
      return dispatch({
        type: 'success',
        payload: payload
      });
    }
  };
}

exports.useLoadingState = useLoadingState;
